import "./i18n"; // Initialize i18next
import "./styles/index.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { queryClient } from "./app/api/queryClient";
import { AuthProvider } from "./app/auth/AuthContext";
import { SettingsProvider } from "./app/context/SettingsContext";
import { router } from "./app/routes-new.tsx";
import {
  ErrorFallback,
  initSentry,
  SentryErrorBoundary,
} from "./app/utils/sentry";

// Initialize Sentry (only in production)
initSentry();

// Initialize MSW in development
async function enableMocking(): Promise<ServiceWorkerRegistration | undefined> {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW === "true") {
    const { worker } = await import("./mocks/browser");
    return worker.start({
      onUnhandledRequest: "bypass",
    });
  }
  return undefined;
}

enableMocking().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <SentryErrorBoundary fallback={<ErrorFallback />}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <SettingsProvider>
              <RouterProvider router={router} />
            </SettingsProvider>
          </AuthProvider>
        </QueryClientProvider>
      </SentryErrorBoundary>
    </StrictMode>,
  );
});
